import querystring from "querystring"

export default class URLUtils {
  static query(){
    return window.location.search.substring(1);
  }

  static params(){
    return querystring.parse(this.query());
  }

  static addQueryParam(url, name, value){
    //https://stackoverflow.com/a/6021027
    var i = url.indexOf('#');
    var hash = i === -1 ? ''  : url.substr(i);
          url = i === -1 ? url : url.substr(0, i);

    var re = new RegExp("([?&])" + name + "=.*?(&|$)", "i");
    var separator = url.indexOf('?') !== -1 ? "&" : "?";
    if (url.match(re)) {
        url = url.replace(re, '$1' + name + "=" + value + '$2');
    } else {
        url = url + separator + name + "=" + value;
    }
    return url + hash;
  }

  static getQueryParam(url, name) {
    //https://stackoverflow.com/a/901144
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results || !results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
